// extracted by mini-css-extract-plugin
module.exports = {"content":"_3XLGVui","background":"_3EG_yUf","banner":"_AgATVRT","bannerImage":"_1hmOKyF","bannerMobile":"_3BWfVdp"};